export default __webpack_public_path__ + "static/TIMBERLINE-S-SERIES-24-C-front-WEB-baad41a6974864485b912aca465681ca.png";